<!-- Header -->
<h1 class="py-3">
    <i class="{{data.icon ? data.icon : 'fa fa-info-circle'}} d-block pb-3"></i> {{data.title | translate}}
</h1>
<button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>

<!-- Message -->
<p>{{data.message | translate}}</p>

<div [formGroup]="dialogGroup">

    <!-- Toggle -->
    <mat-slide-toggle [color]="'primary'" *ngIf="data.toggle" (change)="onChange($event)"
        [checked]="data?.toggle?.value">
        {{data.toggle.title | translate}}
    </mat-slide-toggle>

    <!-- Input -->
    <mat-form-field appearance="outline" class="w-100" *ngIf="!data?.toggle || data?.toggle?.value">
        <mat-label>{{data.inputTitle | translate}}</mat-label>

        <textarea class="in-text-areas" matInput placeholder="{{data.inputTitle | translate}}"
            *ngIf="data.type == 'text'" formControlName="inputValue"></textarea>

        <input matInput type="password" *ngIf="data.type == 'password'" formControlName="inputValue" />
    </mat-form-field>
    <div class="text-danger" *ngIf="hasError">{{hasError | translate}}</div>
</div>

<!-- Buttons -->
<div class="mt-5" [formGroup]="dialogGroup">
    <button class="button bblg sm-100 my-3" (click)="confirm()" [disabled]="dialogGroup.status == 'INVALID'">
        {{data.confirm | translate}}
    </button>
    <button class="button bblg sm-100 my-3" (click)="dialogRef.close()" *ngIf="data.cancel">{{ data.cancel |
        translate}}</button>
</div>